import { render, staticRenderFns } from "./ViewPcrRapidTest.vue?vue&type=template&id=3f16249b&scoped=true&"
import script from "./ViewPcrRapidTest.vue?vue&type=script&lang=js&"
export * from "./ViewPcrRapidTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f16249b",
  null
  
)

export default component.exports